import { accountOwnerType, accountOwnerTypeMap } from 'src/const/agent';
import apis from 'src/const/apis';
import { invoicePresentMap } from 'src/const/state/account';
import * as types from 'src/store/types';
import request from 'src/utils/request';

const bc = {
  namespaced: true,
  state: {
    showCompleteBcAccess: false,
    showCompleteBcPartner: false,
    invoiceInfo: {}, // 开票信息
    info: {
      registeredArea: '',
      orgId: '',
    },
    billingConfig: {
      taxInfo: {},
    },
  },
  getters: {
    canShowInvoiceInfo: (state) => {
      const { present_info: status } = state.invoiceInfo;
      return (status !== undefined) && (status !== invoicePresentMap.HIDE);
    },
  },
  mutations: {
    [types.SET_SHOW_BC_SECTION](state, data) {
      state.showCompleteBcAccess = data.showCompleteBcAccess;
      state.showCompleteBcPartner = data.showCompleteBcPartner;
    },
    [types.SET_INVOICE_INFO](state, data = {}) {
      state.invoiceInfo = data;
    },
    [types.SET_BC_INFO](state, data = {}) {
      state.info = {
        registeredArea: data.registered_area,
        bcId: data.org_id,
      };
    },
    [types.SET_BILLING_CONFIG](state, data = {}) {
      state.billingConfig = {
        taxInfo: data.tax_info_mapping,
      };
    },
  },
  actions: {
    getBcManageList({ commit, getters }, data) {
      return request.get(apis.bc.bc_manage_list, data).then(({ data }) => {
        if (!data) {
          return data;
        }
        const accountOwner = data.account_owner_type;
        const list = data.organizations;
        const showCompleteBcAccess = !getters.isBeCompleted && (accountOwnerTypeMap[accountOwner] !== undefined);
        const showCompleteBcPartner = !getters.isBeCompleted && (accountOwner === accountOwnerType.BC) && list.length;

        commit(types.SET_SHOW_BC_SECTION, { showCompleteBcAccess, showCompleteBcPartner });
        return data;
      });
    },
    accountRemoveBc({ commit }, data) {
      return request.post(apis.bc.account_remove_bc, data);
    },
    getInvoiceInfo({ commit }) {
      return request.get(apis.bc.billing_info).then((res) => {
        const { data } = res;
        commit(types.SET_INVOICE_INFO, data);
        return data;
      });
    },
    updateInvoiceInfo({ commit }, data) {
      return request.post(apis.bc.billing_info, data);
    },
    getBcInfo({ commit }) { // 目前只在开票区域请求
      return request.get(apis.bc.info).then(({ data }) => {
        commit(types.SET_BC_INFO, data);
        return data;
      });
    },
    getBillingConfig({ commit }) {
      return request.get(apis.bc.billing_config).then(({ data }) => {
        commit(types.SET_BILLING_CONFIG, data);
        return data;
      });
    },
  },
};

export default bc;
